import React, { useState, useEffect } from 'react';
import classes from './InvoiceNew.module.css';
import { Container, Card } from 'react-bootstrap';
import Olarms from '../../assets/OGUN STATE LOGO 3.png'

import { NavLink, useLocation, useNavigate } from 'react-router-dom';

import {QRCodeSVG} from 'qrcode.react';


const InvoiceNew = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const [currentDateTime, setCurrentDateTime] = useState('');



    useEffect(() => {
      const addLeadingZero = (number) => (number < 10 ? `0${number}` : number);
    
      const currentDate = new Date();
      const day = currentDate.getDate();
      const month = addLeadingZero(currentDate.getMonth() + 1);
      const year = currentDate.getFullYear();
      const minutes = addLeadingZero(currentDate.getMinutes());
      const hours = addLeadingZero(currentDate.getHours() % 12 || 12);
      const seconds = addLeadingZero(currentDate.getSeconds());
      const ampm = currentDate.getHours() >= 12 ? 'PM' : 'AM';
    
      const formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;
    
      setCurrentDateTime(formattedDateTime);
    }, []);
    
    const { userData,  } = location.state || {};
   
    console.log(userData);
    const handlePrint = () => {
      window.print();
    };

    const formatDateTime = (dateString) => {
      if (!dateString) return "";
    
      const date = new Date(dateString);
    
      return date.toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    };


  return (
    // className={classes.head}
    <div className={classes.container}>
      <div className={classes.card}>
        <div className={classes.cardbody}>
          <div id="invoice">
            <div className={classes.toolbarhiddenprint}>
              <div className={classes.textend}>
                <button onClick={handlePrint} type="button" className="btn btn-success"><i className="fa fa-print" ></i> Print</button>
                {/* <button type="button" className="btn btn-danger"><i className="fa fa-file-pdf-o"></i> Export as PDF</button> */}
              </div>
              <hr />
            </div>
            <div className="{classes.invoice overflow-auto}">
              <div style={{ minWidth: '600px' }}>
                <header>
                  <div className={classes.headerCont}>
                        <img src={Olarms}  alt="Logo" style={{width: 150, height: 100, objectFit: 'contain'}}/>
                 
                   
                    <div className={classes.colcompanydetails}>
                      <h2 className={classes.colorgreenh2}>
                        
                        OGUN STATE BUREAU OF PUBLIC PROCUREMENT
                     
                      </h2>
                      <p> Bureau Of Public Procurement, Oke-Ilewo, Abeokuta, Ogun State</p>
                      <h4 >+234-807 3060 709</h4>
                                       
                      <div ><a className={classes.emCol} href="mailto:ogbpp@ogunstate.gov.ng" data-cfemail="cdaea2a0bdaca3b48da8b5aca0bda1a8e3aea2a0">ogbpp@ogunstate.gov.ng</a></div>
                    </div>
                  </div>
                </header>
                <hr />
                <main className={classes.fullmargin}>
                  <div className={classes.rowcontacts}>
                    <div className={classes.lnne}/>
                    <div className={classes.colinvoiceto}>
                      <div className={classes.invTxt}>{userData?.status_label === "Pending" ? "INVOICE TO" : "RECEIPT TO"}:</div>
                      <h2 className={classes.invTxt1}>{userData.company_name}</h2>
                      <div className={classes.invTxt2}>{userData.company_address}</div>
                      <div >
                        <a href="/cdn-cgi/l/email-protection#016b6e696f416479606c716d642f626e6c"><span className="__cf_email__" data-cfemail="dbb1b4b3b59bbea3bab6abb7bef5b8b4b6">{userData.company_email}</span></a>
                      </div>
                    </div>
                    <div className={classes.colinvoicedetails}>
                      <div className={classes.headercolor}>{userData?.status_label === "Pending" ? "INVOICE" : "RECEIPT"}</div>
                      <div>Date of {userData?.status_label === "Pending" ? "Invoice" : "Receipt"}: {userData?.status_label === "Pending" ? formatDateTime(userData?.created_at) : formatDateTime(userData?.updated_at)}</div>
                      {/* <div >Due Date: 30/10/2018</div> */}
                    </div>
                  </div>
                  <div className={classes.rowcontactss}>
                    <div className={classes.colinvoicetos}>
                      <div className={classes.invTxt31}>Payment Code:</div>
                      <div className={classes.invTxt3}>{userData.payment_code}</div>
                    </div>
                    <div className={classes.colinvoicedetails}>
                    <QRCodeSVG value={userData.payment_url} size={100}/>
                    </div>
                  </div>
                  <table className={classes.tableeepd}>
                    <thead>
                      <tr>
                        <th className={classes.textcent1213}>#</th>
                        <th className={classes.textleft}>DESCRIPTION</th>
                        {/* <th className={classes.textright}>QTY</th> */}
                        <th className={classes.textright11}>TOTAL AMOUNT PAYABLE</th>
                        <th className={classes.textright1s}>TOTAL</th>
                      </tr>
                    </thead>
                    <tbody>
                   {[userData]?.map((item, index) => (
  <tr key={item.id}>
    <td className={classes.textbackc}>{index + 1}</td>

    <td className={classes.textleft}>{item.description}</td>

    <td className={classes.textright1}>
      {new Intl.NumberFormat("en-NG", {
        style: "currency",
        currency: "NGN",
      }).format(Number(item.amount))}
    </td>

    <td className={classes.textrights}>
      {new Intl.NumberFormat("en-NG", {
        style: "currency",
        currency: "NGN",
      }).format(Number(item.amount))}
    </td>
  </tr>
))}
                     
                     
                    </tbody>
                    
                  </table>

                  <div className={classes.belowData}>
                   
                      <div className={classes.belowDatas}>
                        <p className={classes.textleft222}>SUBTOTAL</p>
                        <p className={classes.textleft222}>{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(userData.amount)}</p>
                        </div>
                        <div style={{ width: '70%', borderTop: '2px solid #ccc', marginTop: -20, marginBottom: 10 }} />
                        <div className={classes.belowDatas}>
                        <td className={classes.textleft22212}>GRAND TOTAL</td>
                        <td className={classes.textleft22212}>{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(userData.amount)}</td>
                        </div>
                    </div>
                  {/* <div className="thanks">Thank you!</div> */}
                  {userData?.status_label === "Pending" && (
  <>
    <div
      className={classes.noticetexta}
      style={{ pageBreakBefore: "always", breakBefore: "page" }}
    >
      <h4>STEPS TO MAKE YOUR PAYMENT</h4>
    </div>

    <div className={classes.btmCards}>
      <div className={classes.noticetext}>
        <h4>ONLINE</h4>
      </div>
      <div className={classes.noticetexts}>
        <h4>BANK BRANCH (for Bank Tellers)</h4>
      </div>
    </div>

    <div className={classes.btmCards}>
      <div className={classes.noticetext}>
        <ul>
          <li>
            Visit{" "}
            <a
              style={{ color: "#0087C3" }}
              href="https://pay.ogunstate.gov.ng"
              target="_blank"
              rel="noopener noreferrer"
            >
              pay.ogunstate.gov.ng
            </a>
          </li>
          <li>Enter the payment code</li>
          <li>Input the Captcha and click "Get Details"</li>
          <li>Select "Card" and click on the gateway to use</li>
          <li>Click on "Make Payment" and continue the process</li>
        </ul>
      </div>

      <div className={classes.noticetexts}>
        <ul>
          <li>
            A Teller logs in to{" "}
            <a
              style={{ color: "#0087C3" }}
              href="https://www.remita.net"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.remita.net
            </a>{" "}
            or a Bank application
          </li>
          <li>Go to the "Payments" menu and select "Pay Taxes"</li>
          <li>Select "Ogun State Inland Revenue Service"</li>
          <li>Select "Pay with Payment Code"</li>
          <li>Input the Payment Code and click "SEARCH"</li>
          <li>Complete the transaction</li>
        </ul>
      </div>
    </div>

    <div className={classes.btmCards}>
      <div className={classes.noticetext}>
        <ul>
          <li>
            Visit{" "}
            <a
              style={{ color: "#0087C3" }}
              href="https://pay.ogunstate.gov.ng"
              target="_blank"
              rel="noopener noreferrer"
            >
              pay.ogunstate.gov.ng
            </a>
          </li>
          <li>Enter the payment code</li>
          <li>Input Captcha and click "Get Details"</li>
          <li>Select "Bank Transfer"</li>
          <li>Click "Make Payment"</li>
        </ul>
      </div>

      <div className={classes.noticetexts}>
        <ul>
          <li>Login into the system</li>
          <li>Select the state (e.g., Ogun State)</li>
          <li>Select “Pay with Assessment/Bill (Payment Code)”</li>
          <li>Enter the Payment Code</li>
          <li>Click "Search"</li>
          <li>Complete the transaction</li>
        </ul>
      </div>
    </div>
  </>
)}
                </main>
               
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InvoiceNew;